import styles from './Alert.module.css'

const VARIANT_CLASS = {
  success: styles.success,
  error: styles.error,
  warning: styles.warning,
  info: styles.info,
}

export function Alert({ variant = 'info', children, className, role }) {
  if (!children) return null

  const resolvedRole = role ?? (variant === 'error' ? 'alert' : 'status')
  const classes = [styles.alert, VARIANT_CLASS[variant] || VARIANT_CLASS.info, className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} role={resolvedRole}>
      {children}
    </div>
  )
}
